import Swiper from "swiper";
import { Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs, EffectFade, Autoplay, EffectCoverflow, Grid } from "swiper/modules";
/**
 * @param swiperInit
 */
export default function swiperInit() {
	new Swiper(".section-home-banner .swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 1000,
		loop: true,
		autoplay: {
			delay: 3500,
		},
		modules: [Pagination, Navigation, Autoplay],
		pagination: {
			el: ".section-home-banner .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".section-home-banner .btn-next",
			prevEl: ".section-home-banner .btn-prev",
		},
	});
	new Swiper(".section-home-3 .wrap-product-swiper .swiper", {
		slidesPerView: 2,
		slidesPerGroup: 2,
		spaceBetween: 15,
		speed: 1000,
		modules: [Pagination, Navigation],
		pagination: {
			el: ".section-home-3 .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".section-home-3 .btn-next",
			prevEl: ".section-home-3 .btn-prev",
		},
		breakpoints: {
			768: {
				spaceBetween: 15,
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			1024: {
				spaceBetween: 20,
				slidesPerView: 4,
				slidesPerGroup: 2,
			},
			1200: {
				spaceBetween: 40,
				slidesPerView: 4,
				slidesPerGroup: 2,
			},
		},
	});
	const slideTabHome4 = new Swiper(".section-home-4 .wrap-wrap-slide-tab .swiper", {
		speed: 1000,
		slidesPerView: "auto",
		slideToClickedSlide: "true",
		modules: [Navigation],
	});
	$('.section-home-4 .wrap-product .btn-next').on('click', function () {
		const totalSlide = $('.section-home-4 .wrap-product .swiper-slide').length;
		const currentSlide = $('.section-home-4 .wrap-product .swiper-slide.active').index();
		const nextSlide = currentSlide + 1;
		console.log("🚀 ~ nextSlide:", nextSlide)
		if (nextSlide < totalSlide) {
			slideTabHome4.slideTo(nextSlide);
			$('.section-home-4 .wrap-product .swiper-slide').eq(nextSlide).addClass('active').siblings().removeClass('active');
			$('.section-home-4 .wrap-product .swiper-slide').eq(nextSlide).find('.item-text').trigger('click')
		} else {
			slideTabHome4.slideTo(0);
			$('.section-home-4 .wrap-product .swiper-slide').eq(0).addClass('active').siblings().removeClass('active');
			$('.section-home-4 .wrap-product .swiper-slide').eq(0).find('.item-text').trigger('click')
		}
	});
	new Swiper(".section-home-6 .wrap-product-swiper .swiper", {
		slidesPerView: 2,
		slidesPerGroup: 2,
		spaceBetween: 15,
		speed: 1000,
		autoplay: {
			delay: 3500,
		},
		modules: [Pagination, Navigation],
		pagination: {
			el: ".section-home-6 .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".section-home-6 .btn-next",
			prevEl: ".section-home-6 .btn-prev",
		},
		breakpoints: {
			768: {
				spaceBetween: 15,
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			1024: {
				spaceBetween: 20,
				slidesPerView: 4,
				slidesPerGroup: 2,
			},
			1200: {
				spaceBetween: 40,
				slidesPerView: 4,
				slidesPerGroup: 2,
			},
		},
	});
	new Swiper(".section-home-6 .swiper", {
		slidesPerView: 2,
		spaceBetween: 15,
		speed: 1000,
		modules: [Pagination, Navigation],
		pagination: {
			el: ".section-home-6 .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".section-home-6 .btn-next",
			prevEl: ".section-home-6 .btn-prev",
		},
		breakpoints: {
			768: {
				spaceBetween: 15,
				slidesPerView: 3,
			},
			1024: {
				spaceBetween: 20,
				slidesPerView: 3,
			},
			1200: {
				spaceBetween: 40,
				slidesPerView: 3,
			},
		},
	});
	new Swiper(".section-about-7 .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		speed: 1000,
		modules: [Pagination, Navigation],
		pagination: {
			el: ".section-about-7 .swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".section-about-7 .btn-next",
			prevEl: ".section-about-7 .btn-prev",
		},
	});
	// new Swiper(".section-home-7 .swiper", {
	// 	slidesPerView: 2,
	// 	spaceBetween: 15,
	// 	speed: 1000,
	// 	modules: [Navigation, Pagination],
	// 	navigation: {
	// 		nextEl: ".section-home-7 .btn-next",
	// 		prevEl: ".section-home-7 .btn-prev",
	// 	},
	// 	pagination: {
	// 		el: ".section-home-7 .swiper-pagination",
	// 		clickable: true,
	// 	},
	// 	breakpoints: {
	// 		768: {
	// 			spaceBetween: 15,
	// 			slidesPerView: 3,
	// 		},
	// 		1024: {
	// 			spaceBetween: 20,
	// 			slidesPerView: 4,
	// 		},
	// 		1200: {
	// 			spaceBetween: 40,
	// 			slidesPerView: 4,
	// 		},
	// 	},
	// });
	var productThumb = new Swiper(".section-product-detail.section-1 .product-detail-thumbnail .swiper", {
		slidesPerView: 3,
		spaceBetween: 15,
		freeMode: true,
		watchSlidesProgress: true,
		spaceBetween: 10,
		breakpoints: {
			768: {
				spaceBetween: 20,
				slidesPerView: 4,
			},
			1024: {
				spaceBetween: 20,
				slidesPerView: 4,
			},
			1280: {
				spaceBetween: 20,
				slidesPerView: 5,
			},
		},
	});
	var productMain = new Swiper(".section-product-detail.section-1 .product-detail-image .swiper", {
		spaceBetween: 10,
		speed: 500,
		slidesPerView: 1,
		modules: [Navigation, Thumbs],
		navigation: {
			prevEl: ".section-product-detail.section-1 .product-detail-thumbnail .btn-prev",
			nextEl: ".section-product-detail.section-1 .product-detail-thumbnail .btn-next",
		},
		thumbs: {
			swiper: productThumb,
		},
	});
	new Swiper(".section-product-detail.section-1 	.wrap-slide-logo .swiper", {
		spaceBetween: 15,
		speed: 500,
		slidesPerView: 3,
		modules: [Autoplay],
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			768: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});
	$(".swiper-loop-4").each(function (index) {
		$(this).addClass(`swiper-loop-4-${index}`);
		var name = `.swiper-loop-4-${index}`;
		var swiper = new Swiper(`${name} .swiper`, {
			slidesPerView: 2,
			spaceBetween: 15,
			loop: true,
			modules: [Pagination, Navigation],
			pagination: {
				el: `${name} .swiper-pagination`,
				clickable: true,
			},
			navigation: {
				nextEl: `${name} .btn-next`,
				prevEl: `${name} .btn-prev`,
			},
			breakpoints: {
				768: {
					spaceBetween: 15,
					slidesPerView: 3,
				},
				1024: {
					spaceBetween: 20,
					slidesPerView: 4,
				},
				1200: {
					spaceBetween: 40,
					slidesPerView: 4,
				},
			},
		});
	});
	// Section Affiliate
	var swiperAff = new Swiper(".section-affiliate.section-2 .swiper", {
		spaceBetween: 15,
		speed: 500,
		slidesPerView: 1,
		modules: [Pagination, Navigation],
		pagination: {
			el: `.section-affiliate.section-2 .swiper-pagination`,
			clickable: true,
		},
		navigation: {
			nextEl: `.section-affiliate.section-2 .btn-next`,
			prevEl: `.section-affiliate.section-2 .btn-prev`,
		},
		on: {
			slideChange: function () {
				const index = this.realIndex;
				console.log(index);
				$(".section-affiliate.section-2 .wrap-step .step").eq(index).addClass("active").siblings().removeClass("active");
			},
		},
	});
	$(".section-affiliate.section-2 .wrap-step .step").on("click", function () {
		const index = $(this).index();
		swiperAff.slideTo(index);
	});
	new Swiper(".section-about.section-3 .swiper", {
		spaceBetween: 15,
		speed: 500,
		slidesPerView: 2,
		modules: [Pagination, Navigation],
		pagination: {
			el: `.section-about.section-3 .swiper-pagination`,
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 40,
			},
		},
	});
}
